import { type Address, type PendlePtLockTokenId, PENDLE_PT_LOCK_TOKEN_IDS } from "@/types";

export const PENDLE_MARKETS: Record<PendlePtLockTokenId, Address> = {
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_SLVLUSD_25SEP2025]: "0xC88FF954d42d3e11D43B62523B3357847C29377c",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_SUSDE_25SEP2025]: "0xA36b60A14A1A5247912584768C6e53E1a269a9F7",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_USDE_25SEP2025]: "0x6d98a2b6CDbF44939362a3E99793339Ba2016aF4",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_USR_4SEP2025]: "0x33BdA865c6815c906e63878357335B28f063936c",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_WSTUSR_25SEP2025]: "0x09fA04Aac9c6d1c6131352EE950CD67ecC6d4fB9",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_TUSDE_25SEP2025]: "0x07b1711d4af74af661dde3b774741993b79fc59c",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_PUSDE_16OCT2025]: "0xf4c449d6a2d1840625211769779ada42857d04dd",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_SUSDE_27NOV2025]: "0xb6ac3d5da138918ac4e84441e924a20daa60dbdd",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_USDE_27NOV2025]: "0x4eaa571eafcd96f51728756bd7f396459bb9b869",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_WSRUSD_30OCT2025]: "0x358e4ced73861514bc4918eec59c0ba729b8ccf5",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_SYRUPUSDC_30OCT2025]: "0x8f7eddfa1a03d872da73d9588b040b608238f863",
    [PENDLE_PT_LOCK_TOKEN_IDS.PT_TUSDE_18DEC2025]: "0xf342d4bde4ec5b4bba94c17ab4c92ee3792abd5e",
};
